<template>
	<div>
		<div class="container">
			<div class="d-flex d-flex justify-content-between">
				<div class="input-group col-8 px-0 py-2">
					<div class="input-group-prepend">
						<b-btn 
							class="btn btn-outline-secondary text-dark my-1"
							variant="btn-outline-secondary"
							@click="window.history.back();"
						>Zurück</b-btn>
					</div>
					<div class="input-group-append">
						<b-btn 
							class="btn btn-outline-secondary my-1"
							variant="btn-outline-secondary"
							@click="window.location = '/logoutandredirecttostockscan'" 
						>{{user}} ausloggen</b-btn> <!-- wrong redirect! -->
							<!-- https://stackoverflow.com/questions/43585416/how-to-logout-and-redirect-to-login-page-using-laravel-5-4 -->
					</div>
				</div>
				<h3 class="my-2 py-2">{{vendors[vendorId]}}</h3><!--4011846009498, single: 5099950488629-->
			</div>
			
			<div v-bind:class="divClass">
				<div class="input-group-prepend">
					
					 <span v-if="selectedStock.articleCondition == 1" class="icon input-group-text mx-auto">NEW</span>
					  <span v-else-if="selectedStock.articleCondition == 2" class="icon input-group-text mx-auto">USED</span>
				</div>
				<input
					type="text"
					style="text-align: right;"
					v-bind:class="computedClassEan"
					placeholder="EAN"
					onClick="this.select();"
					v-model="scannedEan"
					ref="refEan"
				>
			</div>

			<div v-bind:class="divClass">
				<input type="text" style="text-align: right;" class="form-control" placeholder="Ort" 		 v-model="selectedStock.stockyard.left">
				<input type="text" style="text-align: right;" class="form-control" placeholder="Lieferant"	 v-model="selectedStock.stockyard.middle">
				<input type="text" style="text-align: right;" class="form-control" placeholder="Preis"		 v-model="selectedStock.stockyard.right">
			</div>

			<div v-if="stocks != null && stocks.length > 0">
				<span v-for="stock in stocks" v-bind:key="stock.id">
					<font size="+1">[{{stock.vendorId}}]<b>{{stock.vendorName}}</b> {{Number(stock.purchasePrice)}}€ {{Number(stock.quantity)}}Stk; </font>
				</span>
			</div>

			<div v-bind:class="divClass">
				 <div class="input-group-prepend">
					 <span class="icon input-group-text icon-list-numbered mx-auto"></span>
				</div>
				<input type="text" style="text-align: right;" class="form-control" placeholder="Anzahl"  v-model="selectedStock.quantity">
			</div>

			<div v-bind:class="divClass">
				 <div class="input-group-prepend">
					 <span class="icon input-group-text icon-coin-euro mx-auto"></span>
				</div>
				<input type="text" style="text-align: right;" class="form-control" placeholder="Preis" v-model="selectedStock.price">
			</div>

			<div class="py-2">
				<button type="button" class="input-group-append btn btn-lg btn-primary btn-block mb-1 float-right" :disabled="errorState" style="padding-top: 5px" @click="save()">
					<span v-if="errorState" class="icon icon-cross mx-auto"></span>
					<span v-else class="icon icon-checkmark mx-auto"></span>
				</button>
			</div>

			<div>
				<b-modal v-model="modalShow" 
					centered			
					hide-footer hide-header 
					no-close-on-esc
					no-close-on-backdrop
				>
					<div slot="modal-header" class="w-100">
						Bitte wählen Sie einen Artikelzustand aus.
					</div>
					<button type="button" class="input-group-append btn btn-primary btn-lg btn-block"
					@click="transferStock('new')">
						<span class="align-center">neu</span>
					</button> 
					<hr/><hr/><hr/>
					<button type="button" class="input-group-append btn btn-lg btn-primary btn-block mb-1"
					@click="transferStock('used')">gebraucht</button>

					<div slot="modal-footer" class="w-100"></div>
				</b-modal>
			</div>


		</div>
	</div>

</template>

<script>
    export default {
		props: ['passedVendors', 'passedUser', 'passedVendorId'],
        data() {
            return {
				vendorId: this.passedVendorId,
				vendors: this.passedVendors,
				user: this.passedUser.user,
				scannedEan: '',
				selectedStock: this.emptyStock(),
				stockResponse: {
					state: -1, //1:new, 2:used, 3:both
					new: this.emptyStock(),
					used: this.emptyStock()
				},
				modalShow: false,
				selectedArticleCondition: null,
				stockDump: null,	
				stocks: null,
				df: null,
				errorState: null,
				divClass: {
					'input-group': true,
					'input-group-lg': true,
					'pb-1': true
				},
            }
        },

		computed: {
			computedClassEan: function () { //4011846009498
				if(this.errorState == null)
				{

					return {
						'form-control': true,
						'bg-danger': false,
						'bg-success': false
					};
				}
				return {
					'form-control': true,
					'bg-danger': this.errorState,
					'bg-success': !this.errorState
				};
			}
		},
	
		watch: {
			
			scannedEan: function(eanNew, eanOld) {

				this.scannedEan = eanNew;
				if(eanNew.length == 0)
				{
					this.errorState = null;
					//this.selectedStock.stockyard = _.mapValues(this.selectedStock.stockyard, () => null);
					this.selectedStock = null;
					this.selectedStock = this.emptyStock();
				}

				this.getArticleDebounced();


			}
		},
		
		methods: {
			getStocksByMaterial() {

				if (!this.errorState) {
					// get all stocks with the same materialId (hence with the same EAN)
					let req = {
						params:{
							materialId: this.selectedStock.materialId,
							articleCondition: this.selectedStock.articleCondition
						}
					};
					console.dir(req);
					axios.get('/stock/getbymaterial', req)
					.then((response) => {
						this.stocks = response.data;
						this.stocks.sort((v, w) => { return v.purchasePrice - w.purchasePrice });

						for(let stock of this.stocks)
						{
							var vendorName = this.vendors[stock.vendorId];
							if(vendorName.length > 10)
							{
								stock.vendorName = vendorName.substring(0,4) + '⋅⋅' + vendorName.substring(vendorName.length - 4, vendorName.length);
							}
							else
							{
								stock.vendorName = vendorName;
							}
						}
					})
					.catch((error) => {
						console.dir(error);
					});
				}	
			},
			transferStock(cond) {
				if(cond === 'new') {
					this.selectedStock = this.stockResponse.new;
				}else if(cond == 'used') {
					this.selectedStock = this.stockResponse.used;
				}
				this.getStocksByMaterial();
				this.modalShow = false;
			},
			emptyStock()
			{
				return {
						stockId: '',
						stockyard: {
							data: '',
							left: '',
							middle: '',
							right: '',
						},
						quantity: '',
						price: '',
						articleCondition: 0,
						materialId: '',
						errorState: '',						
				};
			},

			getArticleDebounced: function () { //calls this.df
				if (this.scannedEan != undefined && this.scannedEan.toString().length > 1)
				{
					this.df.call();
				}
			},

			save()
			{
				if(this.scannedEan == '' || this.scannedEan == null)
				{
					alert('EAN muss angegeben werden.');
					return;
				}
				if(this.selectedStock.quantity == null)
				{
					alert('Menge muss angegeben werden.');
					return;
				}
				if(this.selectedStock.price == '' || this.selectedStock.price == null)
				{
					alert('Preis muss angegeben werden.');
					return;
				}
				var	newArticleId = (this.selectedStock.stockyard.left + '-' + this.selectedStock.stockyard.middle + '-' + this.selectedStock.stockyard.right);
			
				var req = {
					id: 			this.selectedStock.stockId,
					quantity: 		this.selectedStock.quantity,
					articleId: 		newArticleId,
					purchasePrice:	this.selectedStock.price,
					user:			this.user
				};
			
				console.dir(req);

				axios.post('/stock/save', req)
				.then((response) => {
					this.scannedEan = '';
					this.stocks = null;
					this.selectedStock = {};
					this.selectedStock = this.emptyStock();
					this.stockResponse = {};
					this.stockResponse.new = this.emptyStock();
					this.stockResponse.used = this.emptyStock();
					this.errorState = null;
					this.$refs.refEan.focus(); //sets focus
				})
				.catch(function (error) {
					alert("Änderungen wurden aufgrund eines Fehlers verworfen.");
				});

			},

			logout()
			{
				axios.post('/logout', {})
					.then ((response) => {
						//redirect to login page
					})
					.catch((error) => {
						console.dir(error);
					});
			},
		},

		created()
		{
			this.df = _.debounce(
						() => {
							//reset all fields, except the ean!
							this.stockResponse = {};
							this.stockResponse.new = this.emptyStock();
							this.stockResponse.used = this.emptyStock();
							this.stockResponse.state = null;
							this.selectedStock = {};
							this.selectedStock = this.emptyStock();

							const request = {
								params: {
									scannedEan: this.scannedEan,
									vendorId: this.vendorId
								}
							}

							axios.get('/stock/get', request)
							.then(
								(response) => {
									
									//clear stock response
									this.selectedArticleCondition = null;
									this.stockResponse = null;
									this.stockResponse= {
										new: this.emptyStock(),
										used: this.emptyStock()
									}

									this.errorState = (response.data == '');
									if(response.data.size == 0) {
										this.errorState = true;
										return;//						TODO is this return right? <_--------------------
									}
									var counter = 0
									for(let stock of response.data) {
										counter++;
										if(stock.articleCondition == 1) {
											this.stockResponse.new.stockId 			= stock.id;
											this.stockResponse.new.stockyard.data	= stock.articleId;
											this.stockResponse.new.quantity			= stock.quantity;
											this.stockResponse.new.price 			= parseFloat(stock.purchasePrice).toFixed(2).toString();
											this.stockResponse.new.materialId 		= stock.materialId;
											this.stockResponse.new.articleCondition	= 1;
											
											this.stockResponse.new.errorState 		= false;

											var parsedArticleId = this.stockResponse.new.stockyard.data.split('-');
											console.dir(parsedArticleId);
											if(parsedArticleId.length != 3)
											{
												alert('Fehler: articleId (Lagerplatzfeld) hat nicht genau drei Bindestriche');
											}else{
												this.stockResponse.new.stockyard.left	= parsedArticleId[0];
												this.stockResponse.new.stockyard.middle	= parsedArticleId[1];
												this.stockResponse.new.stockyard.right	= parsedArticleId[2];
											}
										}
										else
										{
											this.stockResponse.used.stockId 		= stock.id;
											this.stockResponse.used.stockyard.data	= stock.articleId;
											this.stockResponse.used.quantity		= stock.quantity;
											this.stockResponse.used.price 			= parseFloat(stock.purchasePrice).toFixed(2).toString();
											this.stockResponse.used.materialId 		= stock.materialId;
											this.stockResponse.used.articleCondition= 2;
											this.stockResponse.used.errorState 		= false;

											var parsedArticleId = this.stockResponse.used.stockyard.data.split('-');
											if(parsedArticleId.length != 3)
											{
												alert('Fehler: articleId (Lagerplatzfeld) hat nicht genau drei Bindestriche');
											}else{
												this.stockResponse.used.stockyard.left	 = parsedArticleId[0];
												this.stockResponse.used.stockyard.middle = parsedArticleId[1];
												this.stockResponse.used.stockyard.right	 = parsedArticleId[2];
											}
										}
									}
									if(response.data.length == 1) {
										if(response.data[0].articleCondition == 1) {
											this.selectedStock = this.stockResponse.new;
										}else{
											this.selectedStock = this.stockResponse.used;
										}
										this.getStocksByMaterial(this.selectedStock.materialId);
									}else if(response.data.length == 2) {
										this.modalShow = true;
										this.stockResponse.state = 3;
										this.selectedStock = this.emptyStock();
									}
									//simply load both stocks into used and new, if both set modal to true
									//only request stock data, if the last request has been found (i.e. valid ean)
								}
							).catch(
								(error) =>
								{
									if(this.errorState == false)
									{
										this.$refs.refEan.select(); //sets focus
									}
									this.errorState = true;
									return;
								}
							)
						},
						250,
						{
							maxWait:650
						}
					)
		},

		mounted()
		{
			this.$refs.refEan.focus(); //sets focus

			this.stockResponse= {
				new: this.emptyStock(),
				used: this.emptyStock()
			}

		}

	}

</script>